import { render, staticRenderFns } from "./UsuarioForm.vue?vue&type=template&id=3a4ed08d&"
import script from "./UsuarioForm.vue?vue&type=script&lang=js&"
export * from "./UsuarioForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports